import React from 'react';
import { StyledListItem } from './index.styles.js';
export const ListItemCustom = ({ children }) => (React.createElement(StyledListItem, { custom: true }, children));
//# sourceMappingURL=list-item-custom.js.map